import React from 'react';
import { Button } from '@neshane/blueberry';
import { useProviderHealth } from '../hooks';
import ProviderHealthCard from '../components/ProviderHealthCard';
import { PageEmptyState, Spinner } from '../../../common/components';

function OperationsHealthContainer() {
    const { providers, loading, error, refresh } = useProviderHealth();

    if (error) {
        return <p className="body-m text-secondary-alert-default">{error}</p>;
    }

    return (
        <div className="flex flex-col gap-24">
            <div className="flex items-center justify-between">
                <div className="flex flex-col gap-4">
                    <h1 className="heading-l text-primary">سلامت سرویس‌ها</h1>
                    <p className="body-m text-secondary-bg-primary">
                        وضعیت مدارشکن سرویس‌های خارجی ({providers.length} سرویس)
                    </p>
                </div>
                <Button text="بروزرسانی" iconName="arrow-path" variant="secondaryNeutral" onClick={refresh} />
            </div>

            {loading ? (
                <div className="flex flex-col items-center justify-center gap-16 py-64 text-secondary-bg-primary">
                    <Spinner />
                    <p className="body-m">در حال بارگذاری وضعیت سرویس‌ها...</p>
                </div>
            ) : providers.length === 0 ? (
                <PageEmptyState
                    iconName="shield-star"
                    iconVariant="info"
                    title="سرویسی ثبت نشده است"
                    description="هنوز وضعیتی برای سرویس‌های خارجی ثبت نشده است"
                />
            ) : (
                <div className="grid grid-cols-2 gap-16">
                    {providers.map((provider) => (
                        <ProviderHealthCard key={provider.provider} provider={provider} />
                    ))}
                </div>
            )}
        </div>
    );
}

export default OperationsHealthContainer;
